import { Injectable, ViewContainerRef } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/retry';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(public toasts: ToastsManager,
                public translate: TranslateService) {
    }

    /**
     * Intercept request and if an error occurs, display a toast notification to logged use
     * @param request
     * @param next
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .catch((err: HttpErrorResponse) => {
                if (err.error instanceof Error) {   // client-side or network error occurred
                    // this.toasts.error(this.translate.instant('toast.error') + err.error.message);
                } else {    // backend error
                    // this.toasts.error(this.translate.instant('toast.errorCode') +  `${err.status} : ${err.error}`);
                }
                return Observable.empty<HttpEvent<any>>();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/http-interceptor.ts